import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 1",
  "description": "",
  "published": "2007-09-19T00:00:00.000Z",
  "redirect_from": ["/blog/london-1/swizec/157"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Pozdravljeni na prvi blog s potovanja v London. Zaradi tezav z javnim racunalnikom, ki je uspesno popapcal cel slovenski post se prosim obrnite na `}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/lang=en"
      }}>{`anglesko verzijo`}</a>{` iste vsebine.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      